import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import { SampleProps } from "../../types/sample";

export interface ClosedSampleState {
  samples: SampleProps[];
  totalSamples: number;
  search: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: ClosedSampleState = {
  samples: [],
  totalSamples: 0,
  search: null,
  loading: false,
  error: null,
};

export const fetchClosedSamplesData = createAsyncThunk(
  "fetchClosedSamplesData",
  async (req: { page: number; search?: string }) => {
    let response: any;
    await GET(`/v1/worker/samples`, { ...req, status: 1 })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const closedSampleSlice = createSlice({
  name: "closedSample",
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<string | null>) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClosedSamplesData.pending, (state, action: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchClosedSamplesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        if (
          action.payload.data.data.records.length > 0 &&
          action.payload.data.data.page > 1
        )
          state.samples = [
            ...state.samples,
            ...action.payload.data.data.records,
          ];
        else state.samples = action.payload.data.data.records;
        state.totalSamples = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.samples = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
  },
});

export const { updateSearch } = closedSampleSlice.actions;

export const getSamples = (state: RootState) => state.closedSample.samples;

export const getTotalSamples = (state: RootState) =>
  state.closedSample.totalSamples;

export const getSearch = (state: RootState) => state.closedSample.search;

export default closedSampleSlice.reducer;
